import React, { FunctionComponent } from "react";
import { createTable } from "../util/jsonTableTransform";

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IATableProps {
    product: string;
}

export const IATable: FunctionComponent<IATableProps> = ({ product }) => {
    return (
        <>
            { createTable(product) }
            <h3>Action Links</h3>
            { createTable(product, true) }
        </>
    );
};
